import { NavigationGuard, NavigationGuardNext, Route } from 'vue-router'
import { serviceLocatorInstance } from '@/services/ServiceLocator'
import { IAuthService } from '@/services/auth/IAuthService'
import { IUserService } from '@/services/user/IUserService'

const authenticationLicenseGuard: NavigationGuard = (to: Route, from: Route, next: NavigationGuardNext) => {
  const authService = serviceLocatorInstance.get<IAuthService>('auth')
  const userService = serviceLocatorInstance.get<IUserService>('user')
  if (!authService.isAuthenticated() || !userService.isUserlicensed()) {
    next({
      name: 'Auth',
      params: {
        to: to.fullPath,
      },
    })
    return
  }
  next()
}

export default authenticationLicenseGuard
